"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfoStepPutBodyAllOfToJSON = exports.PersonalInfoStepPutBodyAllOfFromJSONTyped = exports.PersonalInfoStepPutBodyAllOfFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function PersonalInfoStepPutBodyAllOfFromJSON(json) {
    return PersonalInfoStepPutBodyAllOfFromJSONTyped(json, false);
}
exports.PersonalInfoStepPutBodyAllOfFromJSON = PersonalInfoStepPutBodyAllOfFromJSON;
function PersonalInfoStepPutBodyAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'biographicInfo': !runtime_1.exists(json, 'biographicInfo') ? undefined : _1.PreBiographicInfoStepPutBodyFromJSON(json['biographicInfo']),
    };
}
exports.PersonalInfoStepPutBodyAllOfFromJSONTyped = PersonalInfoStepPutBodyAllOfFromJSONTyped;
function PersonalInfoStepPutBodyAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'biographicInfo': _1.PreBiographicInfoStepPutBodyToJSON(value.biographicInfo),
    };
}
exports.PersonalInfoStepPutBodyAllOfToJSON = PersonalInfoStepPutBodyAllOfToJSON;
//# sourceMappingURL=PersonalInfoStepPutBodyAllOf.js.map